// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/landing",
    name: "Landing",
    component: () => import("../views/landing.vue"),
    // meta can be added if needed
  },
  {
    path: "/login",
    name: "login",
    meta: {
      auth: true,
      page_code: "",
    },
    component: () => import("../pages/signup.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    meta: {
      auth: false,
      page_code: "",
    },
    component: () => import("../pages/signup.vue"),
  },
  {
    path: "/approvelogin",
    name: "ApproveLogin",
    meta: {
      auth: false,
      page_code: "",
    },
    component: () => import("../pages/Approvelogin.vue"),
  },
  {
    path: "/newlogin",
    name: "NewLogin",
    meta: {
      auth: false,
      page_code: "",
    },
    component: () => import("../pages/Newlogin.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: () => import("../pages/newindex.vue"),
    meta: {
      auth: false,
      page_code: "",
    },
    children: [
      {
        path: "", // empty path means this will be the default child route
        name: "home",
        meta: {
          auth: false, // Changed from true to false to match parent
          page_code: "",
        },
        component: () => import("../pages/index.vue"),
      },
    ],
  },
  {
    path: "/old-home",
    name: "OldHome",
    component: () => import("../pages/index.vue"),
    meta: {
      auth: false,
      page_code: "",
    },
  },
  {
    path: "/products",
    name: "ProductsPage",
    component: () => import("../pages/Products.vue"),
    meta: {
      auth: false,
      page_code: "",
    },
  },
  {
    path: "/previously-ordered",
    name: "PreviouslyOrdered",
    component: () => import("../pages/FrequentlyOrdered.vue"),
    meta: {
      auth: false,
      page_code: "",
    },
  },
   {
    path: '/profile/password',
    name: "ChangePassword",
    component: () => import("../pages/ChangePassword.vue"),
    meta: {
      auth: true,
      page_code: "",
    },
  },
   {
    path: '/profile/:tab?',
    name: "ProfilePage",
    component: () => import("../pages/Profile.vue"),
    meta: {
      auth: true,
      page_code: "",
    },
  },
   {
    path: "/cart",
    name: "CartPage",
    component: () => import("../pages/cart.vue"),
    meta: {
      auth: true,
      page_code: "",
    },
  },
    {
    path: "/neworder",
    name: "NewOrderPage",
    component: () => import("../pages/Neworder.vue"),
    meta: {
      auth: true,
      page_code: "",
    },
  },
   {
    path: "/ordersuccess",
    name: "OrderSuccessPage",
    component: () => import("../pages/Ordersuccess.vue"),
    meta: {
      auth: true,
      page_code: "",
    },
  },
  {
    path: "/orders",
    name: "Orders",
    component: () => import("../pages/Orders.vue"),
    meta: {
      auth: true,
      page_code: "",
    },
  },
  {
    path: "/market",
    name: "OroMarketingPage",
    component: () => import("../pages/Marketing.vue"),
    meta: {
      auth: false,
      page_code: "",
    },
  },
  {
    path: "/favorites",
    name: "FavoritesPage",
    component: () => import("../pages/Favorites.vue"),
    meta: {
      auth: true,
      page_code: "",
    },
  }
  // Add more routes here if needed
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when navigating to a new route
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0, behavior: 'smooth' };
    }
  },
});

// Navigation guard
router.beforeEach((to, from, next) => {
  const login = (localStorage.getItem("LOGIN") || "").toLowerCase();
  const isAdmin = localStorage.getItem("isadmin");

  // Public pages anyone (logged out or pending) can access
  const publicPaths = ["/", "/newlogin", "/login", "/signup", "/approvelogin", "/products", "/market"];

  // Not logged in → allow public pages, otherwise redirect to login
  if (!login && isAdmin !== "true") {
    if (publicPaths.includes(to.path)) {
      return next();
    }
    return next("/login");
  }

  // Login is pending and no isadmin → allow public pages, otherwise login
  if (login === "pending" && isAdmin !== "true") {
    if (publicPaths.includes(to.path)) return next();
    return next("/login");
  }

  // Login is pending and isadmin is true → allow into the app
  if (login === "pending" && isAdmin === "true") {
    if (["/approvelogin", "/login"].includes(to.path)) {
      return next("/");
    }
    return next();
  }

  next();
});

export default router;
